<div class="classes-calendar" [ngClass]="{ 'no-top-margin': roleId == '4' }">
  <full-calendar [options]="calendarOptions" [events]="events">
    <ng-template #eventContent let-arg>
      <!-- Hidden classes (e.g. holidays) show only their title -->
      <div
        *ngIf="arg.event.extendedProps?.extraParams?.hideDetails === 1"
        class="classes-calendar__hidden"
      >
        {{ arg.event.title }}
      </div>
      <ng-container
        *ngIf="arg.event.extendedProps?.extraParams?.hideDetails !== 1"
      >
        <p-overlayPanel #test>
          <div class="classes-calendar__overlay">
            <span
              class="classes-calendar__month__title classes-calendar__week__title classes-calendar__overlay__mobile"
              ><span
                *ngIf="arg.event.extendedProps?.extraParams?.title"
                class="classes-calendar__event-title"
                >{{ arg.event.extendedProps?.extraParams?.title }}</span
              >{{ arg.event.extendedProps?.extraParams?.course }} -
              {{ arg.event.extendedProps?.extraParams?.subject_display_name }}</span
            >
            <span
              class="classes-calendar__month__time classes-calendar__week__time classes-calendar__overlay__mobile"
              >{{ arg.event.extendedProps?.extraParams?.startTime }} ({{
                timezone
              }})</span
            >
            <span>Tutor: {{ arg.event.extendedProps?.extraParams?.tutor }}</span>
            <a
              class="classes-calendar__link"
              [ngStyle]="{ 'background-color': arg.borderColor }"
              [ngClass]="{
                'classes-calendar__link--inperson':
                  arg.event.extendedProps?.extraParams?.type === 1,
                'classes-calendar__link--online':
                  arg.event.extendedProps?.extraParams?.type === 2,
                'classes-calendar__link--hybrid':
                  arg.event.extendedProps?.extraParams?.type === 3
              }"
              [href]="arg.event.extendedProps?.extraParams?.classUrl || ''"
              target="_blank"
              >Join</a
            >
            <span class="classes-calendar__day__type">{{
              arg.event.extendedProps?.extraParams?.type_display_name
            }}</span>
          </div>
        </p-overlayPanel>
        <div
          *ngIf="arg.view.type === 'dayGridMonth'"
          (click)="test.show($event)"
          class="classes-calendar__month"
        >
          <span class="classes-calendar__month__title"
            ><span
              *ngIf="arg.event.extendedProps?.extraParams?.title"
              class="classes-calendar__event-title"
              >{{ arg.event.extendedProps?.extraParams?.title }}</span
            >{{ arg.event.extendedProps?.extraParams?.course }} -
            {{ arg.event.extendedProps?.extraParams?.subject_display_name }}</span
          >
          <span class="classes-calendar__month__time"
            >{{ arg.event.extendedProps?.extraParams?.startTime }} ({{
              timezone
            }})</span
          >
        </div>
        <div
          *ngIf="arg.view.type === 'timeGridWeek'"
          class="classes-calendar__week"
          (click)="test.show($event)"
        >
          <div class="classes-calendar__week__title">
            <span
              *ngIf="arg.event.extendedProps?.extraParams?.title"
              class="classes-calendar__event-title"
              >{{ arg.event.extendedProps?.extraParams?.title }}</span
            >{{ arg.event.extendedProps?.extraParams?.course }} -
            {{ arg.event.extendedProps?.extraParams?.subject_display_name }}
          </div>
          <span class="classes-calendar__month__time"
            >{{ arg.event.extendedProps?.extraParams?.startTime }} ({{
              timezone
            }})</span
          >
          <span class="classes-calendar__week__tutor"
            ><b>{{ arg.event.extendedProps?.extraParams?.tutor }}</b></span
          >
          <a
            class="classes-calendar__link classes-calendar__link--week"
            [href]="arg.event.extendedProps?.extraParams?.classUrl || ''"
            target="_blank"
            [ngStyle]="{ color: arg.borderColor }"
            >Join</a
          >
        </div>
        <div
          *ngIf="arg.view.type === 'timeGridDay'"
          class="classes-calendar__day"
        >
          <img
            src="assets/Rectangle 2037.webp"
            class="classes-calendar__day__image"
          />
          <span class="classes-calendar__day__title"
            ><span
              *ngIf="arg.event.extendedProps?.extraParams?.title"
              class="classes-calendar__event-title"
              >{{ arg.event.extendedProps?.extraParams?.title }}</span
            >{{ arg.event.extendedProps?.extraParams?.course }} -
            {{ arg.event.extendedProps?.extraParams?.subject_display_name }}</span
          >
          <span class="classes-calendar__day__type">{{
            arg.event.extendedProps?.extraParams?.type_display_name
          }}</span>
          <span class="classes-calendar__day__tutor"
            >Tutor: {{ arg.event.extendedProps?.extraParams?.tutor }}</span
          >
          <a
            class="classes-calendar__link"
            [href]="arg.event.extendedProps?.extraParams?.classUrl || ''"
            target="_blank"
            [ngStyle]="{ color: arg.borderColor }"
            >Join</a
          >
        </div>
        <div
          *ngIf="arg.view.type === 'timeGridDay'"
          class="classes-calendar__day__mobile"
          (click)="test.show($event)"
        >
          <img
            src="assets/Rectangle 2037.webp"
            class="classes-calendar__day__image"
          />
          <span class="classes-calendar__day__title"
            ><span
              *ngIf="arg.event.extendedProps?.extraParams?.title"
              class="classes-calendar__event-title"
              >{{ arg.event.extendedProps?.extraParams?.title }}</span
            >{{ arg.event.extendedProps?.extraParams?.course }} -
            {{ arg.event.extendedProps?.extraParams?.subject_display_name }}</span
          >
          <span class="classes-calendar__day__tutor"
            >Tutor: {{ arg.event.extendedProps?.extraParams?.tutor }}</span
          >
        </div>
      </ng-container>
    </ng-template>
  </full-calendar>
</div>

<p-dialog
  [(visible)]="dataLoading"
  [modal]="true"
  [blockScroll]="true"
  [closeOnEscape]="true"
  [closable]="true"
  [showHeader]="false"
  appendTo="body"
  contentStyleClass="loader"
  styleClass="loaderContainer"
>
  <!-- <mat-spinner>Please wait</mat-spinner> -->
  <p-progressSpinner strokeWidth="4"></p-progressSpinner>
</p-dialog>
